import { safeSanitize } from '../../utils/safe_sanitize';

angular.module("LeasePilot").directive("userFormModal", [
  "$mdDialog",
  "UsersService",
  "UserHelperService",
  function($mdDialog, UsersService, UserHelperService) {
    return {
      restrict: "E",
      templateUrl: "user_form_modal.html",
      scope: {
        type: "@",
        id: "@",
        firstName: "@",
        lastName: "@",
        email: "@",
        role: "@",
        password: "@"
      },
      link: function($scope) {
        // Helper function to sanitize text input to prevent XSS and malicious code
        function sanitizeInput(text) {
          if (!text || typeof text !== 'string') return text || '';
          // Remove Angular interpolation markers first to prevent expression evaluation
          let cleanText = text.replace(/{{.*?}}/g, '');
          // Strip all HTML tags and attributes to prevent XSS
          cleanText = safeSanitize(cleanText, {
            allowedTags: [],
            allowedAttributes: [],
          });
          return cleanText.trim();
        }

        $scope.showMask = true;
        $scope.isProcessing = false;
        $scope.isValidating = false;

        // Initialize user object
        $scope.user = {
          firstName: "",
          lastName: "",
          email: "",
          role: "user",
          password: ""
        };

        if ($scope.type === 'update') {
          // Sanitize values coming from attributes
          $scope.user.firstName = sanitizeInput($scope.firstName || "");
          $scope.user.lastName = sanitizeInput($scope.lastName || "");
          $scope.user.email = sanitizeInput($scope.email || "");
          $scope.user.role = sanitizeInput($scope.role || "user");
        }

        $scope.cancel = function() {
          if ($scope.type === "create") {
            window.track.event(new CancelCreateNewUserEvent());
          } else if ($scope.type === "update") {
            window.track.event(new CancelEditUserEvent({
              id: $scope.id,
            }));
          }
          $mdDialog.cancel();
        };

        $scope.generatePassword = async function() {
          window.track.event(new GeneratePasswordEvent());
          $scope.user.password = UserHelperService.generatePassword();
          await $scope.validateBeforeCreate();

          setTimeout(() => {
            document.querySelector("#password").select();
          });
        };

        $scope.validateBeforeCreate = async function() {
          $scope.safeApply(() => {
            $scope.isValidating = true;
          });

          try {
            const isValid = await UserHelperService.validate({
              type: "create",
              firstName: $scope.user.firstName || "",
              lastName: $scope.user.lastName || "",
              email: $scope.user.email || "",
              password: $scope.user.password || "",
              role: $scope.user.role
            });

            $scope.safeApply(() => {
              $scope.isValid = isValid;
            });
          } finally {
            $scope.safeApply(() => {
              $scope.isValidating = false;
            });
          }
        };

        $scope.validateBeforeUpdate = async function() {
          $scope.safeApply(() => {
            $scope.isValidating = true;
          });

          try {
            const isValid = await UserHelperService.validate({
              type: "update",
              id: $scope.id,
              firstName: $scope.user.firstName || "",
              lastName: $scope.user.lastName || "",
              email: $scope.user.email || "",
              role: $scope.user.role
            });

            $scope.safeApply(() => {
              $scope.isValid = isValid;
            });
          } finally {
            $scope.safeApply(() => {
              $scope.isValidating = false;
            });
          }
        };

        $scope.create = async function() {
          $scope.safeApply(() => {
            $scope.isValidating = true;
          });

          try {
            const isValid = await UserHelperService.validate({
              type: "create",
              firstName: $scope.user.firstName,
              lastName: $scope.user.lastName,
              email: $scope.user.email,
              password: $scope.user.password,
              role: $scope.user.role,
            });

            $scope.isValid = isValid;

            if (isValid.all) {
              $scope.safeApply(() => {
                $scope.isProcessing = true;
              });
              
              // Sanitize all user input before saving
              const data = {
                firstName: sanitizeInput($scope.user.firstName),
                lastName: sanitizeInput($scope.user.lastName),
                email: sanitizeInput($scope.user.email),
                password: $scope.user.password, // Password doesn't need sanitization for XSS
                role: sanitizeInput($scope.user.role),
              };

              UserHelperService.create(data).then(
                response => {
                  window.track.event(new CreateNewUserEvent(data));
                  window.location.reload();
                },
                error => {
                  console.error(error);
                  $scope.safeApply(() => {
                    $scope.error = error.message;
                    $scope.isProcessing = false;
                  });
                }
              );
            }
          } finally {
            $scope.safeApply(() => {
              $scope.isValidating = false;
            });
          }
        };

        $scope.update = async function() {
          $scope.safeApply(() => {
            $scope.isValidating = true;
          });

          try {
            const isValid = await UserHelperService.validate({
              type: "update",
              id: $scope.id,
              firstName: $scope.user.firstName,
              lastName: $scope.user.lastName,
              email: $scope.user.email,
              role: $scope.user.role,
            });

            $scope.isValid = isValid;

            if (isValid.all) {
              $scope.safeApply(() => {
                $scope.isProcessing = true;
              });

              // Sanitize all user input before saving
              const data = {
                id: $scope.id,
                firstName: sanitizeInput($scope.user.firstName),
                lastName: sanitizeInput($scope.user.lastName),
                email: sanitizeInput($scope.user.email),
                role: sanitizeInput($scope.user.role),
              };

              UserHelperService.update(data).then(
                response => {
                  window.track.event(new EditUserEvent(data));
                  window.location.reload();
                },
                error => {
                  console.error(error);
                  $scope.safeApply(() => {
                    $scope.error = error.message;
                    $scope.isProcessing = false;
                  });
                }
              );
            }
          } finally {
            $scope.safeApply(() => {
              $scope.isValidating = false;
            });
          }
        };
      }
    };
  }
]); 